export default "__VITE_ASSET__CVVZBm5t__"